import RolesUtil from 'permissions/utils/roles';
const ProjectPermissions = {
  canEdit: (stateData, projectID) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(
        stateData,
        projectID,
      ) ||
      RolesUtil.doesUserHaveAdminSupportAccess(stateData, projectID)
    );
  },
  canSoftDelete: (stateData, projectID) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(
        stateData,
        projectID,
      ) ||
      RolesUtil.doesUserHaveAdminSupportAccess(stateData, projectID)
    );
  },
  canRestore: (stateData, projectID) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(
        stateData,
        projectID,
      ) ||
      RolesUtil.doesUserHaveAdminSupportAccess(stateData, projectID)
    );
  },
  canPermanentlyDelete: (stateData, projectID) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(
        stateData,
        projectID,
      ) ||
      RolesUtil.doesUserHaveAdminSupportAccess(stateData, projectID)
    );
  },
  canEnableLegalHold: (stateData, projectID) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(
        stateData,
        projectID,
      ) ||
      RolesUtil.doesUserHaveAdminSupportAccess(stateData, projectID)
    );
  },
  canDisableLegalHold: (stateData, projectID) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
      RolesUtil.doesUserHaveAdminSupportAccess(stateData, projectID)
    );
  },
  canEnableSupportTeamAccess: (stateData, projectID) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData, projectID)
    );
  },
  canEnableTechSupportAccess: (stateData, projectID) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData, projectID)
    );
  },
  canDisableSupportTeamAccess: (stateData, projectID) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(
        stateData,
        projectID,
      ) ||
      RolesUtil.doesUserHaveAdminSupportAccess(stateData, projectID)
    );
  },
  canDisableTechSupportAccess: (stateData, projectID) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData, projectID)
    );
  },
  canEnableCoeTeamAccess: (stateData, projectID) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData, projectID)
    );
  },
  canDisableCoeTeamAccess: (stateData, projectID) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData, projectID)
    );
  },
  canManageUsers: (stateData, projectID) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(
        stateData,
        projectID,
      ) ||
      RolesUtil.doesUserHaveAdminSupportAccess(stateData, projectID)
    );
  },
};
export default ProjectPermissions;
